<template>
  <div style="padding:25px">
    <ListCard :list="create_list" @getCreateInfo="chooseClick" v-if="!createForm"></ListCard>
    <el-dialog class="searchAddBomList" v-if="searchAddProject" :title="$t('message.title.add')"
      :visible.sync="searchAddProject">
      <ProjectTempl @listDbClick="addList"></ProjectTempl>
    </el-dialog>
    <div class="create-item" v-if="createForm">
      <el-form size="mini" ref="form" label-width="160px">
        <el-row>
          <div v-if="byModel">
            <div v-for="(item, index) in pageInfo" :key="index">
              <CreateByModel :page="item" :pageIndex="index" :change.sync="item.value" :pageId='pageId'
                :checkReq.sync="item.req" :totalData='speList' @getData="getData">
              </CreateByModel>
            </div>
          </div>
          <div v-else>
            <div v-for="(item, index) in pageInfo" :key="index">
              <PageList :page="item.column" :pageIndex="index" :change.sync="item.val" :reset="resetNum"
                :checkReq.sync="item.req" :pageId="pageId">
              </PageList>
            </div>
          </div>
        </el-row>
        <el-row style="margin-left:160px">
          <el-form-item>
            <el-button type="primary" :loading="btnLoading" @click="submitForm">{{
              $t("message.button.createNow")
            }}</el-button>
            <el-button @click="reset">{{ $t("message.button.reset") }}</el-button>
            <el-button @click="cancel" type="success">{{ $t("message.button.cancel") }}</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ListCard from "./common/listCard.vue";
// import PageList from "./common/pageList.vue";
import PageList from "./common/projectCreate.vue";
import { getNewData, checkSubformRequied, getSaveUrl } from "../../utils/setDataFormat";

export default {
  name: "CreateProject",
  data() {
    return {
      manufacturerId: "",

      createForm: false,
      pageInfo: [],
      pageId: {},
      pageData: [],
      resetNum: 0,
      typeName: "",
      value: '',

      loading: true,
      create_list: [],
      multiList: [],
      speList: {},

      loading: false,
      createId: 0,
      speVsal: 0,

      searchAddProject: false,
      byModel: false,

      input_width: {
        width: "50%",
      },
      btnLoading: false,
    };
  },
  components: {
    ListCard,
    PageList,
    ProjectTempl: () => import("@/components/SearchAddProjectTempl.vue"),
    CreateByModel: () => import("./common/createProByModel"),
  },
  mounted() { },
  methods: {
    cancel() {
      this.createForm = false;
      this.byModel = false;
      this.pageInfo = [];
    },
    getData(data) {
      this.value = data;
    },
    getMultiList(obj) {
      let arr = [];
      obj.uiTypes.map((i, e) => {
        if (i == 4) {
          return arr.push(obj.ids[e]);
        }
      });
      return arr;
    },

    async chooseClick(e) {

      if (e.id == -201) {
        //通过模板创建项目
        this.searchAddProject = true;
      } else {
        //普通创建项目
        this.pageId = e;
        this.typeName = e.name;
        this.createForm = true;
        const arr = [1, 2, 3].map(i => axios.get(`/pmdm/admin/getVisibleTableColumnInfo/${e.id}/${i}`));
        Promise.all(arr).then(res => {
          let arr = [];
          this.pageInfo = res.map(i => {
            const column = i.data.object.columnInfo;
            const req = getNewData(column).filter(j => j.required);
            arr = [...arr, ...req]
            return { column: i.data, value: {} }
          })
          this.reqFields = arr;
        })
      }
    },
    getDual() {
      const [row] = this.pageInfo;
      const { column: { ids }, val: { cells } } = row;
      console.log(ids);

      const n = ids.indexOf(1051003);
      const dualVal = parseInt(cells[n].val);
      return dualVal
    },
    getSubData() {


      const dualVal = this.getDual();
      console.log(dualVal);
      let m = this.pageInfo.map((i) => i.value);
      console.log(this.pageId);
      m[0]["1051003"] = dualVal * 60 * 60 * 8 * 1000;
      let obj = {
        name: m[0]["1051012"],
        template: m[0]["1051016"],
        createType: 2,
        pageOne: Object.assign(m[0], {
          classId: this.pageId.projectClass,
          rootId: 0,
          parentId: 0,
        }),
        pageTwo: m[1] || {},
        pageThree: m[2] || {},
        objectId: {
          classId: this.pageId.projectClass,
          subClassId: this.pageId.projectSubClass,
          id: this.pageId.projectId,
        },
        isCopyStaff: this.value ? this.value : 0,
      };
      m[0]["1051001"] && Object.assign(obj, { schStartDate: m[0]["1051001"] });
      m[0]["1051002"] && Object.assign(obj, { schEndDate: m[0]["1051002"] });

      this.$http.post("/ppm/project/createTempleteOrObj", obj).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);

          this.pageId = {};
          //this.$store.commit("setClassId", res.data.object.classId);
          //this.$store.commit("setObjID", res.data.object.id);
          //this.$store.commit("setSubClassId", res.data.object.subclassId);
          this.$store.commit("setQuickCreate", {});

          // this.$router.push("/titleBlock");
          // let obj = {
          //   itemClassId: res.data.object.classId,
          //   itemId: res.data.object.id,
          //   itemSubClassId: res.data.object.subclassId,
          // };
          // obj[0] = res.data.object.name;
          // this.getRouteLink(obj);
          const item = {
            ...res.data.object,
            name: res.data.object.name
          }
          this.getLink(item);
        }
      }).catch(_ => {
      })
      // this.byModel = false;
    },

    submitForm() {
      this.btnLoading = true;
      console.log(this.pageInfo);
      const req = this.pageInfo.map((i) => i.req);
      console.log('11111111111', req);

      for (const key in req) {
        if (!req[key] && req[key] != undefined) {
          this.$message.error(this.$t("message.warning.required"));
          return;
        }
      }

      if (this.byModel) {
        this.getSubData();
        return;
      }

      let m = JSON.parse(
        JSON.stringify(
          this.pageInfo.map((i) => {
            if (!Object.keys(i.val).length) {
              return {};
            }
            return i.val;
          })
        )
      );
      console.log(m);

      let obj = {
        pageOne: Object.assign(m[0], {
          classId: this.pageId.clsId,
          rootId: 0,
          parentId: 0,
        }),
        pageTwo: m[1] || {},
        pageThree: m[2] || {},
        objectId: {
          classId: this.pageId.clsId,
          subClassId: this.pageId.id,
          id: "",
        },
      };
      this.submit(obj);

      // if (obj.pageOne[1051003] > 0) {
      //   this.submit(obj);
      // } else {
      //   this.$message.error(this.$t("message.warning.required"));
      // }
    },
    submit(obj) {
      axios.post("/ppm/project/saveProject", obj).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            showClose: true,
            type: "success",
          });
          console.log(res.data);
          this.pageId = {};
          //this.$store.commit("setClassId", res.data.object.classId);
          //this.$store.commit("setObjID", res.data.object.id);
          //this.$store.commit("setSubClassId", res.data.object.subclassId);
          this.$store.commit("setQuickCreate", {});
          // this.$router.push("/titleBlock");
          // let obj = {
          //   itemClassId: res.data.object.classId,
          //   itemId: res.data.object.id,
          //   itemSubClassId: res.data.object.subclassId,
          // };
          // obj[0] = res.data.object.name;
          // this.getRouteLink(obj);
          const item = {
            ...res.data.object,
            name: res.data.object.name
          }
          this.getLink(item);
        }
        this.btnLoading = false;
      });
    },
    addList(row) {
      //通过模板创建项目
      console.log(row);
      this.pageId = row;
      this.searchAddProject = false;
      this.createForm = true;
      this.byModel = true;

      axios
        .get("/ppm/project/createProjectByTemplete?templeteId=" + row.projectId)
        .then((res) => {
          console.log(res.data.object.p1Table);
          this.speList = res.data.object;

          const { p1Table, p2Table, p3Table } = res.data.object;
          this.pageInfo = [p1Table, p2Table, p3Table].map(i => {
            const { columnInfo: column, rows } = i;
            return { column, val: rows[0] }
          })

        });
    },

    reset() {
      this.resetNum++;
    },

    async getLists() {
      const { data: res } = await this.$http.get(
        "/pmdm/admin/cls/getClsesWithSubClses?baseClsId=301"
      );
      var content = res.object.clses;
      for (var i = 0; i < content.length; i++) {
        content[i].show = true;
      }

      content.push;

      this.create_list = content;
      console.log(this.create_list);
    },
  },
  created() {
    this.getLists();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
};
</script>

<style scoped>
.create-item {
  overflow: auto;
  height: 100%;
  padding: 10px 10px;
  background: #fff;
}

.title {
  font-size: 16px;
  /* margin-left: 10px; */
  /* color: #409eff; */
  margin-bottom: 10px;
  margin-top: 20px;
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
}

.title .el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  font-weight: 400;
  /* color: #409eff; */
}

.box-card {
  margin-top: 15px;
  padding-top: 15px;
}

.create-list {
  padding: 0;
  margin: 0;
  overflow: hidden;
  margin-bottom: 30px;
}

.create-list-subClass {
  width: 24%;
  height: 30px;
  float: left;
  text-align: center;
  background: #ebeef5;
  margin-right: 1%;
  margin-top: 10px;
  line-height: 30px;
}

.create-list-subClass:hover {
  cursor: pointer;
  background: #409eff;
  color: #fff;
}

.create-list .create-list-class {
  width: 96%;
  background: rgb(198, 226, 255);
  text-align: left;
  height: 38px;
  line-height: 38px;
  font-size: 18px;
  cursor: default;
  padding-left: 3%;
}
</style>
